export const EBOOK_SIZE = {
  SMALL: 'SMALL',
  LARGE: 'LARGE'
}

export const EBOOK_LOCATION = {
  ARTICLE: 'ARTICLE'
}
